import { GrDashboard, GrPowerReset } from "react-icons/gr";
import { FaCheck, FaCheckDouble, FaUser } from "react-icons/fa";
import { IoCheckmark, IoFolderOpen } from "react-icons/io5";
import {
  BsCalendarCheckFill,
  BsCarFrontFill,
  BsLayoutSplit,
} from "react-icons/bs";
import { RiCheckDoubleLine, RiFileList2Fill } from "react-icons/ri";
import { IoMdStopwatch, IoMdWatch } from "react-icons/io";
import {
  MdTextFields,
  MdImage,
  MdVideocam,
  MdDescription,
} from "react-icons/md";

export const APP_NAME = "Jewellery Hiring | Admin Panel";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const IMAGE_BASE_URL =
  "https://jewelleryhiring.s3.ap-south-1.amazonaws.com/";

export const ACTION_ICON_SIZE = ".875rem";

export const NAVIGATION_ICON = {
  OPEN_ORDER: <IoFolderOpen />,
  USER: <FaUser />,
  RIDE: <BsCarFrontFill />,
  BOOKING: <BsCalendarCheckFill />,
  TEMPLATE: <BsLayoutSplit />,
  CAMPAIGN: <RiFileList2Fill />,
};

export const FILE_TYPE = {
  IMAGE: ["image/png", "image/jpeg", "image/jpg"],
  VIDEO: ["video/mp4", "video/ogg", "video/webm"],
  AUDIO: ["audio/mpeg", "audio/ogg", "audio/wav", "audio/webm", "audio/aac"],
  DOCUMENT: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
};

export const MESSAGE_TYPE = {
  TEXT: 1,
  TEMPLATE: 2,
  IMAGE: 3,
  AUDIO: 4,
  DOCUMENT: 5,
  VIDEO: 6,
};

export const FILE_FORMAT_TYPES = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  DOCUMENT: "DOCUMENT",
};

export const MESSAGE_STATUSES = [
  {
    code: 1,
    key: "TRIED",
    label: "Tried",
    icon: <IoMdStopwatch />, // pending clock
    color: "#999", // grey
  },
  {
    code: 2,
    key: "SENT",
    label: "Sent",
    icon: <IoCheckmark />,
    color: "#999",
  },
  {
    code: 3,
    key: "DELIVERED",
    label: "Delivered",
    icon: <RiCheckDoubleLine />,
    color: "#999",
  },
  {
    code: 4,
    key: "READ",
    label: "Read",
    icon: <RiCheckDoubleLine />,
    color: "#4fc3f7", // WhatsApp blue
  },
  {
    code: 5,
    key: "FAILED",
    label: "Failed",
    icon: <IoMdStopwatch />, // pending clock
    color: "#999",
  },
  {
    code: 6,
    key: " RECIEVED",
    label: "Recieved",
    icon: "",
    color: "red",
  },
];

export const SOCKET_EVENTS = {
  MESSAGE_RECIEVED: "messageRecieved",
  MESSAGE_SENT: "messageSent",
  MESSAGE_DELIVERED: "messageDelivered",
  MESSAGE_READ: "messageRead",
  MESSAGE_FAILED_TO_SEND: "messageFailedToSend",
};

export const RECORD_TYPE = {
  ADMIN: 1,
  USER: 2,
  RIDE: 3,
  BOOKING: 4,
};
export const STATUS = {
  ADMIN: 1,
  CANDIDATES: 2,
};

export const TABLE_ACTION_KEYS = {
  EDIT: "Edit",
  DELETE: "Delete",
  ADD: "Add",
  VIEW: "View",
  RESET: "Reset",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  NAVIGATE: "Navigate",
  DOWNLOAD: "Download",
  IMPORT: "Import",
  CHANGE_PASSWORD: "ChangePassword",
  STATUS: "status",
  VIEW_MORE_INFO: "viewMoreInfo",
  EXPORT: "Export",
  ACTIVITY_LOG: "activityLog",
  HOMESCREEN_VISIBLE: "homeScreenVisibility",
  BLOCK_BULK_ORDER: "blockBulkOrder",
};

export const ACTIVE_INACTIVE_STATUS = [
  {
    label: "Active",
    key: "ACTIVE",
    value: 1,
  },
  {
    label: "Blocked",
    key: "BLOCKED",
    value: 0,
  },
];

export const TOAST_TIMING = 4000;

export const COMMON_DATE_FORMAT = "DD MMMM YYYY hh:mm A";

export const INITIAL_PAGE_COUNT = 25;

export const NO_DATA_FOUND = "-";

// export const NAME_COLUMN_SIZE = "";

export const USER_MANAGEMNT_COMMON_SEARCH_INFO = "Search by name";

export const USER_MANAGEMNT_ACTION_CONSTANT = [
  { label: "Edit", key: TABLE_ACTION_KEYS.EDIT, toolTip: "Edit" },
];
export const RESET_ACTION_CONSTANT = [
  { label: "Reset", key: TABLE_ACTION_KEYS.RESET, toolTip: "Reset Passowrd" },
];

export const IMPORT_FILE_TYPES = {
  CANDIDATES: 1,
  EMPLOYERS: 2,
};
export const EXPORT_FILE_TYPES = {
  CANDIDATES: 1,
  EMPLOYERS: 2,
};

export const QUERY_TYPES = {
  CONTACT: 1,
  EMPLOYERS: 2,
};

export const QUERY_TYPES_OPTIONS = [
  {
    label: "Contact",
    value: QUERY_TYPES.CONTACT,
  },
  {
    label: "Employers",
    value: QUERY_TYPES.EMPLOYERS,
  },
];

export const FILTER_CONSTANT = {
  isSearch: {
    placeholder: USER_MANAGEMNT_COMMON_SEARCH_INFO,
    toolTipText: USER_MANAGEMNT_COMMON_SEARCH_INFO,
  },
  isCalendarFilter: {
    type: "date-range-picker",
    placeholder: "Select date range",
  },

  isResetButton: {
    label: "Reset",
    icon: <GrPowerReset />,
    filterKey: {
      gender: "gender",
      status: "status",
    },
  },
};

export const BASE_URL = "https://api.Jewellery Hiring.com/";

export const GENDER = {
  1: "Male",
  2: "Female",
  3: "Other",
};

export const GENDER_OPTIONS = [
  {
    label: "Male",
    value: 1,
  },
  {
    label: "Female",
    value: 2,
  },
  {
    label: "Other",
    value: 3,
  },
];

export const TEMPLATE_CATEGORIES_OPTIONS = [
  // { label: "Authentication", value: "AUTHENTICATION" },
  { label: "Marketing", value: "MARKETING" },
  { label: "Utility", value: "UTILITY" },
];

export const HEADER_FORMAT_OPTIONS = [
  {
    label: "Text",
    value: "TEXT",
    icon: <MdTextFields color="#4B5563" size={40} />, // Cool gray
  },
  {
    label: "Image",
    value: "IMAGE",
    icon: <MdImage color="#2563EB" size={40} />, // Blue
  },
  {
    label: "Video",
    value: "VIDEO",
    icon: <MdVideocam color="#D97706" size={40} />, // Amber/Orange
  },
  {
    label: "Document",
    value: "DOCUMENT",
    icon: <MdDescription color="#059669" size={40} />, // Emerald/Green
  },
];

export const BUTTON_TYPE_OPTIONS = [
  { label: "Copy Code", value: "COPY_CODE" },
  { label: "Phone Number", value: "PHONE_NUMBER" },
  { label: "Quick Replies", value: "QUICK_REPLY" },
  { label: "URL", value: "URL" },
];
